export default __webpack_public_path__ + "static/LogoLight-91d183edb158faa35cd7cb10b16a8ce4.png";